import { render, staticRenderFns } from "./StartOver.vue?vue&type=template&id=271419ec&"
import script from "./StartOver.vue?vue&type=script&lang=js&"
export * from "./StartOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports